import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private supabase = inject(SupabaseService);

  async getAppointmentStats(branchId: number, period: string) {
    return this.supabase.client.rpc('get_appointment_stats', {
      p_branches_id: branchId,
      p_period: period
    });
  }

  async getPaymentsSummary(branchId: number) {
    return this.supabase.client.rpc('get_payments_summary', {
      p_branches_id: branchId
    });
  }

  async getWeeklyTransactionSummary(branchId: number, startDate: string, endDate: string) {
    return this.supabase.client.rpc('get_weekly_transaction_summary', {
      p_branches_id: branchId,
      p_start_date: startDate,
      p_end_date: endDate
    });
  }

  async getTodayAppointments(branchId: number, statusId: string = '0') {
    return this.supabase.client.rpc('get_today_appointments', {
      p_branches_id: branchId,
      p_status_id: statusId
    });
  }

  async getExpenseRecords(branchId: number) {
    return this.supabase.client.rpc('get_expense_records', {
      p_branches_id: branchId
    });
  }

  getOnlineUsers(branchId: number): Observable<number> {
    const subject = new BehaviorSubject<number>(0);
    const channel = this.supabase.client.channel(`presence:branch:${branchId}`, {
      config: {
        presence: {
          key: 'user',
        },
      },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        const count = Object.keys(state).length;
        subject.next(count);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({ online_at: new Date().toISOString() });
        }
      });

    return subject.asObservable();
  }
}
